import { render } from "./ResidentProvider.vue?vue&type=template&id=788810da"
import script from "./ResidentProvider.vue?vue&type=script&lang=js"
export * from "./ResidentProvider.vue?vue&type=script&lang=js"

import "./ResidentProvider.vue?vue&type=style&index=0&id=788810da&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__